jQuery(function($){

	parentClasses = [
		'.store-item',
		'.single-cs-song-wrapper',
		'.site-sample-player',
		'.release-sample-player',
	];

	$.each(parentClasses, function(i, className){
		$(className + ' .sample-player .play-pause-button:not(.no-audio)').on('click', function(){
			togglePlay($(this), className);
		});

		$(className + ' .voicing-selector .voicing').on('click', function(){
			stopPlayerOnVoicingChange($(this), className);
		});
	});

	let audioLoaded = false;
	$('body, html').bind('touchstart touchmove scroll mousedown DOMMouseScroll mousewheel keyup mouseover', function(e){
		loadAllAudio();
	});  

	function loadAllAudio() {
		if(!audioLoaded) {
			console.log('Loading all audio!');
			audioLoaded = true;
			$('audio').each(function(){
				this.load();
			});
		}
	}

	$('.sample-player').each(function(){
		if($(this).find('.player-tracks').length) {
			let trackDivs = $(this).find('.player-tracks .player-track');
			console.log(trackDivs);

			loadAudio($(trackDivs[0]), false);
		}
	});


	$('.sample-player .player-tracks .player-track').on('click', function(){
		loadAudio($(this), true);
	});

	$('.sample-player .seek-button').on('click', function(){
		const direction = $(this).hasClass('backward') ? 'backward' : 'forward';

		const tracks = $(this).closest('.sample-player').find('.player-track');

		let activeTrackIndex;
		let i = 0;
		tracks.each(function(){
			if($(this).hasClass('active-track')) activeTrackIndex = i;
			i++;
		});

		let newTrackIndex;
		if(direction == 'backward') {
			newTrackIndex = activeTrackIndex == 0 ? i - 1 : activeTrackIndex - 1;
		} else {
			newTrackIndex = activeTrackIndex == i - 1 ? 0 : activeTrackIndex + 1;
		}

		loadAudio($(tracks[newTrackIndex]), true);
	});


	function loadAudio(trackDiv, autoplay = false) {
		stopAllPlayers();

		const playerDiv = trackDiv.closest('.sample-player');
		const tracksWrapperDiv = trackDiv.closest('.player-tracks');

		const title = trackDiv.html();
		const url = trackDiv.attr('song-url');
		const sampleMp3 = trackDiv.attr('sample-mp3');

		const titleHtml = '<div class="title-text"><a href="' + url + '">' + title + '</a></div>';

		tracksWrapperDiv.find('.player-track').removeClass('active-track');
		trackDiv.addClass('active-track');

		playerDiv.find('.track-title').html(titleHtml);
		playerDiv.find('audio').attr('src', sampleMp3);
		if(autoplay) {
			playerDiv.find('audio').each(function(){
				$.each(parentClasses, function(i, className){
					if(playerDiv.closest(className).length) {
						togglePlay(playerDiv, className);
					}
				});
			});
		}

		setTimeout(scrollTitle, 50);
	}

	function togglePlay(el, parentClass) {
		const parentDiv = el.closest(parentClass);
		const isPlaying = parentDiv.hasClass('playing-sample');

		stopAllPlayers(parentClass);

		if(!isPlaying) {
			parentDiv.addClass('playing-sample');
			el.closest('.sample-player').addClass('playing');
			el.closest('.sample-player').find('audio').each(function(){
				this.play();
			});
		}		
	}

	function stopPlayerOnVoicingChange(el, parentClass) {
		const parentDiv = el.closest(parentClass);
		const isPlaying = parentDiv.hasClass('playing-sample');

		const playingClass = $(this).attr('parent-class');

		if(!parentDiv.hasClass(parentClass) && isPlaying) {
			stopAllPlayers(parentClass);
		}
	}

	function stopAllPlayers(parentClass = false, resetToZero = false) {
		let loop = !parentClass ? parentClasses : [parentClass];

		$.each(loop, function(i, parentClass){
			$(parentClass + ' .sample-player audio').each(function(){
				this.pause();
			});
			
			removePlayingClasses(parentClass);
		});
	}

	function removePlayingClasses(parentClass = false) {
		let loop = !parentClass ? parentClasses : [parentClass];

		$.each(loop, function(i, parentClass){
			$(parentClass + ' .sample-player').each(function(){
				$(this).removeClass('playing');
			});

			$(parentClass).each(function(){
				$(this).removeClass('playing-sample');
			});
		});
	}

	setInterval(function(){
		if(audioLoaded) {
			$('audio').each(function(){
				if(this.duration - this.currentTime <= 0) {
					this.currentTime = 0;
					this.pause();
					removePlayingClasses();
				}

				const parentDiv = $(this).closest('.sample-player');
				const scroll = parentDiv.find('.player-scroll');
				const timestampCurrent = parentDiv.find('.timestamp.current');
				const timestampDuration = parentDiv.find('.timestamp.duration');

				// console.log(this.duration);
				// console.log(this.readyState);

				if(this.readyState == 4) {
					// console.log(this.currentTime / this.duration);
					scroll.val(this.currentTime / this.duration);
					if(timestampCurrent.length) timestampCurrent.html(convertToTime(this.currentTime));
					if(timestampDuration.length) timestampDuration.html(convertToTime(this.duration));
				}
			});
		}
	}, 500);

	$('.sample-player .player-scroll').on('change', function(){
		const parentDiv = $(this).closest('.sample-player');
		const audioPlayer = parentDiv.find('audio');
		audioPlayer[0].currentTime = audioPlayer[0].duration * $(this).val();
		console.log($(this).val());
	});

	function zeroPad(num) {
		var zero = 2 - num.toString().length + 1;
		return Array(+(zero > 0 && zero)).join("0") + num;		
	}

	function convertToTime(timeInSeconds) {
		let mins = Math.floor(timeInSeconds / 60);
		let secs = Math.floor(timeInSeconds % 60);

		if(!timeInSeconds) {
			mins = 0;
			secs = 0;
		}

		return mins + ':' + zeroPad(secs);
	}



	setTimeout(scrollTitle, 50);

	let titleScrolling;
	function scrollTitle() {
		let scrollTitles = document.getElementsByClassName('track-title');

		for(var i = scrollTitles.length - 1; i >= 0; i--) {
			// console.log(this.scrolling);

			let wrapper = scrollTitles[i];
			let span = $(scrollTitles[i]).find('.title-text')[0];

			let wrapperWidth = wrapper.getBoundingClientRect().width;
			let spanWidth = span.getBoundingClientRect().width;

			function scrollLeft() {
				let left = parseInt(span.style.left);

				let wrapperWidth = wrapper.getBoundingClientRect().width;
				let spanWidth = span.getBoundingClientRect().width;

				span.style.left = Math.abs(left) > spanWidth && left < 0 ? wrapperWidth + 'px' : left - 1 + 'px';
				
				let scrollTimeout = left == 1 ? 3000 : 20;

				if(spanWidth > wrapperWidth) {
					titleScrolling = setTimeout(scrollLeft, scrollTimeout); //Continue
				} else {
					span.style = ''; //Clear style
				}
			}

			if(spanWidth > wrapperWidth) {
				span.style.left = wrapperWidth + 'px';
				span.style.right = 'initial';
				span.style.transform = 'none';
				scrollLeft();
			}
		}
	}

	function scrollTitleReset() {
		let scrollTitles = document.getElementsByClassName('track-title');
		for(var i = scrollTitles.length - 1; i >= 0; i--) {
			let wrapper = scrollTitles[i];
			let span = $(scrollTitles[i]).find('.title-text')[0];
			span.style = '';
		}
	}

});